import React from 'react';

// Styles & Assets
//import styles from './SonarPatients.module.css';

// Services
import { setColor } from '../../../services/Patient';

// Context
import ColumnsContext from '../../../context/ColumnsContext';
import GeneralContext from '../../../context/GeneralContext';

// Hooks
import { useContext } from 'react';
import useFilteredPatients from '../../../hooks/useFilteredPatients';

// Components
import Table from '../../UI/Table/Table';

// SonarPatients: requests the physiological data of the patients, filters
// it and the columns and renders the Table component.
const SonarPatients: React.FC<{
    handlePatientClick: (id: number) => void,
    activePatientID?: number | null
}> = ({ handlePatientClick, activePatientID }) => {

    const columnsContext = useContext(ColumnsContext);
    const { SONARTableColumnOrder, setSONARTableColumnOrder } = useContext(GeneralContext);

    const { filteredPatients } = useFilteredPatients();

    const handleClickCell = (rowID: number, colID: number) =>
        columnsContext.dispatchSonarSelectedCells({ type: 'SET_CELL', rowID, colID });

    return (
        <Table
            columns={columnsContext.columnsSonar}
            rows={filteredPatients}
            defaultColumnToOrder={[SONARTableColumnOrder, setSONARTableColumnOrder]}
            onClickRow={handlePatientClick}
            onClickCell={handleClickCell}
            activeCells={columnsContext.cellsSonarSelected}
            setColorRow={setColor}
            activeRowID={activePatientID}
        />
    );
};
export default SonarPatients;